import { useEffect, useState } from "react";
import { Route, withRouter } from "react-router-dom";
import Routes from "./Routes";
import { Loader } from "../Components/Common/Loader";
import axios from "axios";
import MaintenanceMode from "../Components/MaintenanceMode";

const Layout = (props) => {
  const [maintenance, setMaintenance] = useState({
    active: 0,
    text: "از اختلال پیش آمده متاسفیم ",
  });
  useEffect(() => {

    axios.get("https://s-plus.ir/api/splash").then((res) => {
      const { maintenanceMode, maintenanceText } = res.data;
      setMaintenance({
        active: maintenanceMode,
        text: maintenanceText,
      });
    })
  }, []);
  return maintenance.active == 1 ? (
    <MaintenanceMode text={maintenance.text} />
  ) : (
    <>
      {!true ? (
        <Loader active />
      ) : (
        <>
          <Route path="/:section?/:part?/:id?" component={Routes} />
        </>
      )}
    </>
  );
};

export default withRouter(Layout);
